var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaningAdvisorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.9,23.4c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4s-4.4-2-4.4-4.4S22.5,23.4,24.9,23.4 M24.9,22.5c-2.9,0-5.3,2.4-5.3,5.3 c0,2.9,2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3C30.2,24.8,27.8,22.5,24.9,22.5L24.9,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,28.2H7.4C7.2,28.2,7,28,7,27.8c0-0.3,0.2-0.5,0.5-0.5h10.9c0.3,0,0.5,0.2,0.5,0.5C18.8,28,18.6,28.2,18.3,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3,28.2H31.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h10.9c0.3,0,0.5,0.2,0.5,0.5C42.8,28,42.6,28.2,42.3,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,21.6c-0.3,0-0.5-0.2-0.5-0.5V10.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v10.9C25.3,21.4,25.1,21.6,24.9,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,45.6c-0.3,0-0.5-0.2-0.5-0.5V34.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v10.9C25.3,45.4,25.1,45.6,24.9,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,23.6c-0.1,0-0.2,0-0.3-0.1l-7.7-7.7c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l7.7,7.7c0.2,0.2,0.2,0.5,0,0.7 C20.5,23.5,20.3,23.6,20.2,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,40.5c-0.1,0-0.2,0-0.3-0.1l-7.7-7.7c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l7.7,7.7c0.2,0.2,0.2,0.5,0,0.7 C37.4,40.5,37.3,40.5,37.2,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,23.6c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l2.1-2.1c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-2.1,2.1 C29.8,23.5,29.7,23.6,29.5,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,40.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l7.7-7.7c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-7.7,7.7 C12.8,40.5,12.7,40.5,12.6,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,20.5c1,2.2,1.5,4.7,1.5,7.3c0,10.2-8.3,18.5-18.5,18.5S6.4,38,6.4,27.8S14.7,9.2,24.9,9.2c3.3,0,6.4,0.9,9.1,2.4 l0.8-0.6c-2.9-1.7-6.3-2.7-9.9-2.7C14.2,8.3,5.5,17,5.5,27.8s8.7,19.4,19.4,19.4s19.4-8.7,19.4-19.4c0-3-0.7-5.8-1.9-8.3L41.9,20.5 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.3,8.8c0.7,1.9,1.9,3.8,3.8,5.1c0.3,0.2,0.6,0.4,0.9,0.5c-0.3,0.1-0.6,0.3-0.8,0.5c-2,1.3-3.2,3.2-3.9,5.1 c-0.7-1.9-1.9-3.8-3.8-5.1c-0.3-0.2-0.6-0.3-0.8-0.5c0.3-0.1,0.6-0.3,0.9-0.5C37.4,12.5,38.6,10.7,39.3,8.8 M39.3,4.5 c-0.9,9.7-7.9,9.9-7.9,9.9s6.9,0,7.9,9.7c1-9.7,8-9.7,8-9.7c0,0,0,0,0,0S40.2,14.2,39.3,4.5L39.3,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,5.8c-1.6,0-2.9-1.3-2.9-2.9S32.8,0,34.4,0c1.6,0,2.9,1.3,2.9,2.9S36,5.8,34.4,5.8z M34.4,0.9c-1.1,0-2,0.9-2,2 s0.9,2,2,2c1.1,0,2-0.9,2-2S35.5,0.9,34.4,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,14.1c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7S30,14.1,29,14.1z M29,11.6c-0.4,0-0.8,0.4-0.8,0.8 c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8C29.8,12,29.5,11.6,29,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,20c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C35.4,19.3,34.8,20,34,20z M34,18 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5C34.5,18.3,34.3,18,34,18z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,17.1l-0.7,0.6c1.6,3,2.5,6.4,2.5,10.1c0,11.8-9.6,21.3-21.3,21.3c-11.8,0-21.3-9.6-21.3-21.3S13.1,6.4,24.9,6.4 c4.1,0,7.9,1.2,11.2,3.2l0.5-0.8c-3.4-2.1-7.4-3.3-11.6-3.3c-12.3,0-22.2,10-22.2,22.2C2.7,40,12.6,50,24.9,50s22.2-10,22.2-22.2 C47.2,23.9,46.2,20.3,44.4,17.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningAdvisorLogo);
export default __webpack_public_path__ + "static/media/cleaning_advisor_logo.1b38bab2330f9b99c2fe858bb228b232.svg";
export { ForwardRef as ReactComponent };